import Button from '@rio-cloud/rio-uikit/Button';
import { useIntl } from 'react-intl';

import { useAppNavigate } from '#routes/AppNavLink.tsx';
import { routes } from '#routes/routes.ts';
import type { OrderWithSortableKey } from '#utils/orders.util.ts';

import LabeledValue from '../../form/LabeledValue.tsx';

type OrderTourDetailsProps = {
    order: OrderWithSortableKey;
};

export const OrderTourDetails = ({ order }: OrderTourDetailsProps) => {
    const intl = useIntl();
    const navigate = useAppNavigate();
    const { tourId, tourName, truck } = order;

    if (!tourId) {
        return null;
    }

    const tourNameLabel = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.orders.details.tour.tour-name',

        defaultMessage: 'Tour name',
    });
    const vehicleLabel = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.orders.details.tour.vehicle',
        defaultMessage: 'Vehicle',
    });
    const openTourLabel = intl.formatMessage({
        id: 'intl-msg:ordercom-cloud-frontend.orders.details.tour.open',
        defaultMessage: 'Open tour',
    });

    const openTour = () => {
        navigate(`${routes.TOURS}/${tourId}`);
    };

    return (
        <div
            className='display-grid grid-cols-2 gap-10 bg-lightest padding-10 rounded'
            data-testid='order-tour-vehicle-info'
        >
            <LabeledValue
                boxed
                label={tourNameLabel}
                value={
                    <Button
                        className='padding-0'
                        data-testid='order-tour-link-button'
                        autoTrackingKey='ordercom.orders.details.tour.open'
                        onClick={openTour}
                        title={openTourLabel}
                        variant='link-inline'
                    >
                        {tourName}
                    </Button>
                }
            />
            <LabeledValue boxed label={vehicleLabel} value={truck?.name} />
        </div>
    );
};
